import {
    CabinetContextApi,
    type CabinetContextApiProps,
} from '@frontend/modules/private/shared/CabinetContext'
import type {CabinetMenuType} from '@frontend/modules/private/shared/CabinetSharedTypes'
import {PrivateRoute} from '@frontend/routes/PrivateRoute'
import clsx from 'clsx'
import {
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react'
import {Outlet} from 'react-router-dom'
import {FadeIn} from 'swayok-react-mdb-ui-kit/components/Animation/FadeIn'
import {ScrollToTop} from 'swayok-react-mdb-ui-kit/components/ScrollToTop'
import {CabinetMenu} from './cabinet_menu/CabinetMenu'

// Разметка ЛК пользователя.
export function CabinetRoutesContainer() {

    const [
        sideMenuType,
        setSideMenuType,
    ] = useState<CabinetMenuType>(null)

    const [
        contentContainerId,
        setContentContainerId,
    ] = useState<string | null>(null)

    const transitionRef = useRef<HTMLDivElement>(null)

    const api: CabinetContextApiProps = useMemo((): CabinetContextApiProps => ({
        setSideMenuType,
        setContentContainerId,
    }), [])

    useEffect(() => {
        setContentContainerId(null)
    }, [location.pathname])

    return (
        <CabinetContextApi.Provider value={api}>
            <PrivateRoute
                permanentKey="cabinet"
                id={contentContainerId}
            >
                <div className="container-fluid container-xl">
                    <ScrollToTop key={location.pathname} />
                    <div
                        className={clsx(
                            'd-flex flex-column align-items-stretch justify-content-start',
                            'flex-lg-row align-items-lg-start justify-content-lg-start col-gap-lg-3'
                        )}
                    >
                        <CabinetMenu type={sideMenuType} />
                        <FadeIn
                            key={location.pathname}
                            long
                            transitionRef={transitionRef}
                        >
                            <div
                                className="flex-1"
                                ref={transitionRef}
                            >
                                <Outlet />
                            </div>
                        </FadeIn>
                    </div>
                </div>
            </PrivateRoute>
        </CabinetContextApi.Provider>
    )
}
